export const symbols = {
  ruble: '₽',
}
